const decorationStore = [
    { prefix: "ct", sessionStorageKey: "cityUrl" },
    { prefix: "mrcht", sessionStorageKey: "merchantUrl" },
];

const changeUrlPrefixToValue = requestHandler => (type, resource, params) => {
    let updatedResource = resource;
    const decorator = decorationStore.find(decoration =>
        resource.includes(`${decoration.prefix}/`)
    );

    if (decorator) {
        const { sessionStorageKey, prefix } = decorator;
        const value = sessionStorage.getItem(`${sessionStorageKey}`);
        if (!value) {
            return Promise.reject(`Unauthorized or Session Expired`);
        }
        updatedResource = resource.replace(`${prefix}/`, `${value}/`);
    }

    // console.log(`Decorated ${resource} to ${updatedResource} with`, decorator);
    return requestHandler(type, updatedResource, params);
};

export const changeUrlValueToPrefix = resource => {
    let updatedResource = resource;
    const decorator = decorationStore.find(decoration =>
        resource.includes(`${sessionStorage.getItem(decoration.sessionStorageKey)}/`)
    );

    if (decorator) {
        const value = sessionStorage.getItem(`${decorator.sessionStorageKey}`);
        updatedResource = resource.replace(`${value}/`, `${decorator.prefix}/`);
    }

    // console.log(`Decorated ${resource} to ${updatedResource} with`, decorator);
    return updatedResource;
};

export default changeUrlPrefixToValue;
